class ComponentsWiesnExportsController {

    constructor($http, FileSaver, SweetAlert, SelectBox, GuestlistShifts, ResourceCommon, Users) {
        this.api = $http;
        this.fileSaver = FileSaver;
        this.sweetAlert = SweetAlert;
        this.selectBox = SelectBox;
        this.shiftsFp = GuestlistShifts;
        this.resourceCommon = ResourceCommon;

        this.specialExports = _.get(Users, 'state.company.settings.oktoberfest.special_dashboard_exports')

        this.currentTab = 'billing';
    }

    exportAvailableTablesByShift() {
        this.selectBox.single(this.shiftsFp, {
            displayField: 'title'
        }).then(response => {
            this.exportAvailableTables(null, response.data);
        }, err => {
            this.sweetAlert.error('Error', 'Error while fetching shifts');
        });
    }

    exportAvailableTables(guestlist, shift) {
        guestlist = guestlist || null;
        shift = shift || null;
        this.downloadFileWithName('exports/seatplan-elements/available', {
            guestlist_id: guestlist,
            shift_id: shift
        }, 'Available Tables.pdf');
    }

    exportDailyReport() {
        this.resourceCommon.dateRangeSelector().then((data) => {
            this.downloadFileWithName('billing/exports/invoices/daily-report', {
                start_date: data.start_date,
                end_date: data.end_date
            }, 'Tagesabrechnung.pdf');
        }, () => {

        });
    }

    exportDailyReportPaulaner() {
        this.resourceCommon.dateRangeSelector().then((data) => {
            this.downloadFileWithName('billing/exports/invoices/daily-report-paulaner', {
                start_date: data.start_date,
                end_date: data.end_date
            }, 'Tagesabrechnung - Paulaner.pdf');
        }, () => {

        });
    }

    exportDailyList() {
        this.resourceCommon.dateRangeSelector().then((data) => {
            this.downloadFileWithName('billing/exports/invoices/daily-list', {
                start_date: data.start_date,
                end_date: data.end_date
            }, 'Tagesliste.pdf');
        }, () => {

        });
    }

    exportDailyListPaulaner() {
        this.resourceCommon.dateRangeSelector().then((data) => {
            this.downloadFileWithName('billing/exports/invoices/daily-list-paulaner', {
                start_date: data.start_date,
                end_date: data.end_date
            }, 'Tagesliste - Paulaner.pdf');
        }, () => {

        });
    }

    exportBidToInvoiceList() {
        this.resourceCommon.dateRangeSelector().then((data) => {
            this.downloadFileWithName('billing/exports/invoices/bid-to-invoice', {
                start_date: data.start_date,
                end_date: data.end_date
            }, 'Bid-To-Invoice.xlsx');
        }, () => {

        });
    }

    exportInvoicedPositions() {
        this.resourceCommon.dateRangeSelector().then((data) => {
            this.downloadFileWithName('billing/exports/invoices/invoiced-positions', {
                start_date: data.start_date,
                end_date: data.end_date
            }, 'Invoiced-Positions.xlsx');
        }, () => {

        });
    }

    exportInvoicedPositionsWithoutBid() {
        this.resourceCommon.dateRangeSelector().then((data) => {
            this.downloadFileWithName('billing/exports/invoices/invoiced-positions-without-bid', {
                start_date: data.start_date,
                end_date: data.end_date
            }, 'Invoiced-Positions-Without-Bid.xlsx');
        }, () => {

        });
    }

    exportInvoicedPositionsWithCancellations() {
        this.resourceCommon.dateRangeSelector().then((data) => {
            this.downloadFileWithName('billing/exports/invoices/invoiced-positions-with-cancellations', {
                start_date: data.start_date,
                end_date: data.end_date
            }, 'Invoiced-Positions-With-Cancellations.xlsx');
        }, () => {

        });
    }

    exportInvoicedPositionsNew() {
        this.resourceCommon.dateRangeSelector().then((data) => {
            this.downloadFileWithName('billing/exports/invoices/invoiced-positions-new', {
                start_date: data.start_date,
                end_date: data.end_date
            }, 'Invoiced-Positions-New.csv');
        }, () => {

        });
    }

    exportInvoicedPositionsWithoutBidNew() {
        this.resourceCommon.dateRangeSelector().then((data) => {
            this.downloadFileWithName('billing/exports/invoices/invoiced-positions-without-bid-new', {
                start_date: data.start_date,
                end_date: data.end_date
            }, 'Invoiced-Positions-Without-Bid-New.csv');
        }, () => {

        });
    }

    exportTaxInfoAugustiner() {
        this.resourceCommon.dateRangeSelector().then((data) => {
            this.downloadFileWithName('billing/exports/tax-info-augustiner', {
                start_date: data.start_date,
                end_date: data.end_date
            }, `tax_report_${data.start_date}_${data.end_date}.xlsx`);
        }, () => {

        });
    }

    exportRsvpsWithoutBids(guestlist) {
        this.downloadFileWithName('exports/rsvps/without-bid', {
            guestlist_id: guestlist
        }, 'Buchungen ohne Vorabrechnung.xlsx');
    }

    exportRsvpsWithoutInvoices(guestlist) {
        this.downloadFileWithName('exports/rsvps/without-invoice', {
            guestlist_id: guestlist
        }, 'Buchungen ohne Rechnung.xlsx');
    }

    downloadFileWithName(path, data, fileName) {
        data = data || {};

        this.api.post(path, data, {responseType: "blob"})
            .then((response) => {
                const blob = new Blob([response.data], {type: response.headers('content-type')});
                this.fileSaver.saveAs(blob, fileName);
            }, (response) => {
                this.sweetAlert.error('Export Error', 'There was an error while preparing the export');
            });
    }

    changeTab(newTab) {
        this.currentTab = newTab;
    }
}

ComponentsWiesnExportsController.$inject = [
    '$http',
    'FileSaver',
    'SweetAlert',
    'SelectBox',
    'GuestlistShifts',
    'ResourceCommon',
    'Users'
];

/**
 * @ngdoc controller
 * @name components.components:ComponentsWiesnExportsController
 * @restrict EA
 * @element
 *
 * @description
 *
 */
angular.module('festzelt-os.components').controller('ComponentsWiesnExportsController', ComponentsWiesnExportsController);



// WEBPACK FOOTER //
// ./src/app/components/components/al-wiesn-exports/controller.js